import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {

    saveApplication(appDto, appId) {
        axios.defaults.withCredentials = true;


        return axios.post(constants.BASE_URL + "/applications/" + appId, appDto).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    },
    getApplicationDetails(appId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/" + appId + "/edit")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                
            });
    },
    getProcesses(appId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/" + appId + "/appprocesses/application-processes")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    getForms(appId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/" + appId + "/appforms/all-forms-application")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    exportAsPDF(appId, appName) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/export/" + appId+"?timezone="+Intl.DateTimeFormat().resolvedOptions().timeZone)
            .then(response => {
                var binaryString = window.atob(response.data.data);
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                var blob = new Blob([bytes], { type: "application/pdf" });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = appName + '.pdf';
                link.click();
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    deployApplication(appId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/deploy/" + appId)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response.data;
            });
    },
    unDeployApplication(appId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/undeploy/" + appId)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response;
            });
    },
    disableApplication(appId, deletedReason) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/applications/" + appId + "/delete", {"deletedReason":deletedReason}).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    enableApplication(appId) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/applications/" + appId + "/restore").then(response => {
            return response.data;
        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    getAppliations(input) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/applications?" + input, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching applications"
                    });
                }
            });
    },
    getApplicationLabels() {
        return axios.get(constants.BASE_URL + "/applications/all-labels", {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    getCopyApplicationDetails(appId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/" + appId + "/copy")
            .then(response => {
                return response.data;
            })
            .catch(error => {
               
            });
    },
    checkDeploymentExpired() {
        return axios.get(constants.BASE_URL + "/applications/deployment-expired", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response;
            });
    }
}
